import type { BadgeTone } from "../../../shared/ui";
import type { AuditActor } from "./auditApi";
import type { AuditKey, AuditTranslate } from "./useAuditT";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value: string): boolean {
  return UUID.test(value.trim());
}

export function outcomeTone(outcome: string): BadgeTone {
  if (outcome === "success") return "success";
  if (outcome === "denied") return "warning";
  return "error";
}

const OUTCOME_KEYS: Record<string, AuditKey> = {
  success: "admin.audit.outcome.success",
  denied: "admin.audit.outcome.denied",
  failure: "admin.audit.outcome.failure",
};

export function outcomeLabel(t: AuditTranslate, outcome: string): string {
  const key = OUTCOME_KEYS[outcome];
  return key === undefined ? outcome : t(key);
}

const SHORT_ID_CHARS = 8;

export function shortId(id: string): string {
  return id.slice(0, SHORT_ID_CHARS);
}

/** Operator name when known, otherwise a short monospace-worthy id. */
export function actorLabel(t: AuditTranslate, actor: AuditActor): string {
  if (actor.display_name) return actor.display_name;
  return actor.kind === "operator"
    ? shortId(actor.id)
    : `${t("admin.audit.actor.other")} ${shortId(actor.id)}`;
}

/** Renders a summary value as text only; objects become compact JSON. */
export function summaryValue(value: unknown): string {
  if (value === null || value === undefined) return "-";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return JSON.stringify(value);
}
